import { Toaster as SonnerToaster, type ToasterProps } from 'sonner';

export function Toaster(props: ToasterProps) {
  return (
    <SonnerToaster
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: 'font-sans border border-border bg-background text-foreground shadow-md',
          title: 'font-display text-base',
          description: 'text-sm text-muted-foreground',
          success: 'border-secondary',
          error: 'border-primary',
          info: 'border-tertiary'
        }
      }}
      {...props}
    />
  );
}
